import { useState } from "react";
import { catalogItems, featuredItems, trendingSeries, topRatedItems } from "@/mocks/movies";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import UpdateTicker from "@/pages/home/components/UpdateTicker";
import CatalogSection from "@/pages/home/components/CatalogSection";
import TrendingSeries from "@/pages/home/components/TrendingSeries";
import TopRated from "@/pages/home/components/TopRated";
import GenreExplore from "@/pages/home/components/GenreExplore";
import GuideFaq from "@/pages/home/components/GuideFaq";
import AboutSection from "@/pages/home/components/AboutSection";
import Footer from "@/pages/home/components/Footer";
import BackToTop from "@/pages/home/components/BackToTop";

export default function Home() {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeCategory, setActiveCategory] = useState("全部");
  const [activeGenre, setActiveGenre] = useState("全部类型");

  const scrollToCatalog = () => {
    const target = document.getElementById("catalog");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleSearch = (term: string) => {
    setSearchTerm(term);
    setActiveCategory("全部");
    setActiveGenre("全部类型");
    scrollToCatalog();
  };

  const handleSelectGenre = (genre: string) => {
    setActiveGenre(genre);
    setActiveCategory("全部");
    setSearchTerm("");
    scrollToCatalog();
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero items={featuredItems} onSearch={handleSearch} />
        <UpdateTicker />
        <CatalogSection
          items={catalogItems}
          searchTerm={searchTerm}
          activeCategory={activeCategory}
          activeGenre={activeGenre}
          onSearchTerm={setSearchTerm}
          onCategoryChange={setActiveCategory}
          onGenreChange={setActiveGenre}
        />
        <TrendingSeries items={trendingSeries} />
        <TopRated items={topRatedItems} />
        <GenreExplore activeGenre={activeGenre} onSelectGenre={handleSelectGenre} />
        <GuideFaq />
        <AboutSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}